import { createReducer } from "@reduxjs/toolkit";
import * as actions from "./actions";
import { StoreState } from "../storeState";

const initialState = {
  data: null,
  state: StoreState.None,
};

export const changeDemandReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(actions.changeDemandFetchRequest, (state) => ({
      ...state,
      state: StoreState.Loading,
    }))
    .addCase(actions.changeDemandFetchSuccess, (state, action) => ({
      ...state,
      state: StoreState.Loaded,
      data: action.payload,
    }))
    .addCase(actions.changeDemandFetchError, (state) => ({
      ...state,
      state: StoreState.Error,
    }))
);
